export const ORDER_ACTION = {
  ORDER_PRODUCT: "ORDER_ACTION/ORDER_PRODUCT",
  GUEST_ORDER_PRODUCT: "ORDER_ACTION/GUEST_ORDER_PRODUCT",
  GET_ORDER_LIST: "ORDER_ACTION/GET_ORDER_LIST",
  GET_ORDER_CODE: "ORDER_ACTION/GET_ORDER_CODE",
  GET_ORDER_DETAIL: "ORDER_ACTION/GET_ORDER_DETAIL",
  GET_GUEST_ORDER_DETAIL: "ORDER_ACTION/GET_GUEST_ORDER_DETAIL",
  UPDATE_ORDER_STATUS: "ORDER_ACTION/UPDATE_ORDER_STATUS",
  GET_ALL_ORDERS: "ORDER_ACTION/GET_ALL_ORDERS",
  CLEAR_ORDER_LIST: "ORDER_ACTION/CLEAR_ORDER_LIST",
};
